module.exports = __webpack_public_path__ + "img/keder_reinweiss_ral9010.0e18b54a.jpg";